import { Component, OnInit } from '@angular/core';
import { CognitoService } from '../service/cognito.service';

@Component({
    selector: 'app-bin-dashboard',
    templateUrl: './bin-dashboard.component.html',
    styleUrl: './bin-dashboard.component.css',
    standalone: false
})
export class BinDashboardComponent implements OnInit{

  constructor(public cognitoService: CognitoService,){

  }

  async ngOnInit() {
    // Check the user roles and validations for user
    await this.cognitoService.confirmValidUser();
    await this.cognitoService.getUserType();
  }
}
